import React, { FC, useCallback, useState } from 'react';

import { BaseControlName } from '../../../types/controls';
import { SettingPopupButton } from '../../skin/setting-popup-button/component';
import { PlayerContentType } from '../../../types/content';
import { useChangeSubtitlesPositionCallback } from '../../../hooks/skin/use-change-subtitles-position-callback';
import MoviePlayerControlPanel from '../../../../movie-player/ui/MoviePlayerControlPanel';
import { FilmAudioSettingsPopupButtonContainer } from '../../../../film-player/ui/FilmAudioSettingsPopupButtonContainer';
import { FilmTimelinePreviewContainer } from '../../../../film-player/ui/FilmTimelinePreviewContainer';

interface FilmPlayerControlPanelProps {
    contentId: string;
    className?: string;
    setIsHidingControlsBlocked: (isHidingControlsBlocked: boolean) => void;
}

const FilmPlayerControlPanel: FC<FilmPlayerControlPanelProps> = ({
    contentId,
    className,
    setIsHidingControlsBlocked,
}) => {
    const [isSubtitleSizeSettingsForceOpened, setIsSubtitleSizeSettingsForceOpened] =
        useState(false);

    const changeSubtitlePosition = useChangeSubtitlesPositionCallback();
    const onPopupToggle = useCallback(
        (isPopupOpened: boolean) => {
            setIsHidingControlsBlocked(isPopupOpened);
            changeSubtitlePosition(isPopupOpened);
        },
        [setIsHidingControlsBlocked, changeSubtitlePosition]
    );

    return (
        <MoviePlayerControlPanel
            contentId={contentId}
            className={className}
            onPopupToggle={onPopupToggle}
            renderTimelineCursor={
                contentId
                    ? (time) => <FilmTimelinePreviewContainer time={time} contentId={contentId} />
                    : undefined
            }
            renderRightControls={() => (
                <>
                    <FilmAudioSettingsPopupButtonContainer
                        contentId={contentId}
                        name={BaseControlName.AUDIO_SUBS_LIST}
                        onSubtitleSizeSettingsClick={() =>
                            setIsSubtitleSizeSettingsForceOpened(true)
                        }
                    />
                    <SettingPopupButton
                        name={BaseControlName.ADJUSTMENT}
                        contentId={contentId}
                        contentType={PlayerContentType.FILM}
                        isSubtitleSizeSettingsForceOpened={isSubtitleSizeSettingsForceOpened}
                        setIsSubtitleSizeSettingsForceOpened={setIsSubtitleSizeSettingsForceOpened}
                    />
                </>
            )}
        />
    );
};

export default FilmPlayerControlPanel;
